import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { motion } from 'framer-motion';
import { Formik } from 'formik';
import * as yup from 'yup';
import { GrLinkedin } from 'react-icons/gr';
import { FaDownload } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';
import { backVariants, fade } from '~/styles/animations';
import Loading from '~/components/Loading';
import useWindowDimensions from '~/hooks/useWindowDimensions';

import { Modal, Toast } from '~/components';

import notebook from '~/assets/img/img-certificado-excel.png';
import logoSemanaPython from '~/assets/img/logo-excel.png';

import api from '~/services/api';

import * as U from '~/styles/utilities';
import * as F from '~/styles/form';

import logo from '~/assets/img/logo.png';
import logoWhite from '~/assets/img/logowhite-l.png';
import * as S from './styled';

const Certificate = () => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);
  const { width } = useWindowDimensions();

  const [loading, setLoading] = useState({ form: false, image: false });

  const [modalCertificate, setModalCertificate] = useState(false);
  const [CertificateData, setCertificateData] = useState({});

  const handleSubmitForm = async (data) => {
    const formattedData = { ...data, key_word: 'excel' };

    try {
      setLoading({ form: true, image: true });
      const response = await api.post('/generate-certificate', formattedData);

      setModalCertificate(true);
      setCertificateData(response.data);
      setLoading({ form: false, image: false });
    } catch (err) {
      Toast.error('Algo deu errado, tente novamente mais tarde');
      setLoading({ form: false, image: false });
    }
  };

  // form

  const initialValues = {
    username: '',
    email: '',
  };

  const validations = () =>
    yup.object().shape({
      username: yup.string().required('O nome é obrigatório'),

      email: yup
        .string()
        .email('Insira um e-mail válido')
        .required('O e-mail é obrigatório'),
    });

  return (
    <>
      <motion.div exit={{ opacity: 0 }} initial="initial" animate="animate">
        <S.BackgroundExcelPage>
          <S.ContainerLimit>
            <U.Gap size={50} />
            <Grid container xs={12} justify="center">
              <Grid item xs={12} sm={4}>
                <img
                  src={logoSemanaPython}
                  alt="logo"
                  style={{ width: '100%' }}
                />
              </Grid>
            </Grid>
            <U.Gap size={100} />
            <Grid container xs={12}>
              <Grid item xs={12} md={6}>
                <Grid xs={12} md={10}>
                  <motion.div variants={fade}>
                    <S.Title spanColor="#33C481">
                      <span>Parabéns</span> por ter chegado ao final do evento!
                    </S.Title>
                    <U.Gap size={12} />
                    <S.Text>
                      Agora chegou a hora de emitir seu certificado!
                    </S.Text>
                    <S.Text>Aproveite esse momento para:</S.Text>
                    <U.Gap size={25} />
                    <Grid xs={12} sm={10}>
                      <S.UList spanColor="#33C481">
                        <li>
                          Compartilhar seu certificado no <span>LinkedIN</span>
                        </li>
                        <li>
                          Seguir a <span>Empowerdata</span> nas Redes Sociais
                        </li>
                        <li>
                          Conhecer nossas{' '}
                          <span>Formações Completas de Excel e Power BI</span>
                        </li>
                      </S.UList>
                    </Grid>
                    <U.Gap size={30}>
                      <S.Text>
                        Obrigado por ter nos acompanhado até aqui!
                      </S.Text>
                    </U.Gap>
                  </motion.div>
                  <Grid container xs={12} justify="center">
                    <Grid item xs={12} sm={6} md={10}>
                      <motion.div variants={fade}>
                        <img
                          src={notebook}
                          alt="logo"
                          style={{ width: '100%' }}
                        />
                      </motion.div>
                    </Grid>
                  </Grid>
                  <U.Gap size={30} />
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                <motion.div initial="exit" animate="enter" exit="exit">
                  <motion.div variants={backVariants}>
                    <S.Card backgroundColor="#616C69">
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                      >
                        <Grid item>
                          <S.TitleModal color="#33C481">
                            <span>Emita seu </span> certificado
                          </S.TitleModal>
                        </Grid>
                        <Grid item>
                          <S.LogoModal src={logo} alt="logo" />
                        </Grid>
                      </Grid>
                      <U.Gap size={20} />
                      <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmitForm}
                        validationSchema={validations()}
                      >
                        {({
                          handleSubmit,
                          handleBlur,
                          handleChange,
                          values,
                          errors,
                          touched,
                          setFieldValue,
                        }) => (
                          <>
                            <form onSubmit={handleSubmit}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <F.Label color="#33C481">
                                    Nome (máx. 30 caracteres)
                                  </F.Label>
                                  <F.Input
                                    type="text"
                                    placeholder="Digite seu nome"
                                    name="username"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.username}
                                    maxLength={30}
                                  />
                                  {errors.username && touched.username ? (
                                    <F.Hint
                                      error={
                                        !!errors.username && touched.username
                                      }
                                    >
                                      {errors.username}
                                    </F.Hint>
                                  ) : null}
                                </Grid>
                                <Grid item xs={12}>
                                  <F.Label color="#33C481">
                                    E-mail cadastrado no evento
                                  </F.Label>
                                  <F.Input
                                    type="email"
                                    placeholder="Digite seu e-mail"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                  />
                                  {errors.email && touched.email ? (
                                    <F.Hint
                                      error={!!errors.email && touched.email}
                                    >
                                      {errors.email}
                                    </F.Hint>
                                  ) : null}
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  container
                                  justify="flex-end"
                                  style={{ margin: '40px 0 32px 0px' }}
                                >
                                  <S.Button
                                    // whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    full
                                    type="submit"
                                    className="flex-center"
                                    disabled={loading.form}
                                    buttonColorHover="#33C481"
                                  >
                                    {loading.form ? (
                                      <>
                                        <span>Emitindo certificado ...</span>
                                        <Loading />
                                      </>
                                    ) : (
                                      'Emita seu Certificado!'
                                    )}
                                  </S.Button>
                                </Grid>
                              </Grid>
                            </form>
                          </>
                        )}
                      </Formik>
                    </S.Card>
                  </motion.div>
                </motion.div>
              </Grid>
            </Grid>
            <U.Gap size={100} />
          </S.ContainerLimit>
        </S.BackgroundExcelPage>

        <S.SeeMoreSection>
          <S.ContainerLimit>
            <Grid container justify="center" className="text-center">
              <Grid>
                <S.TitleBig>Veja mais sobre a </S.TitleBig>
                <S.TitleBig>
                  <span>Empowerdata</span>
                </S.TitleBig>
              </Grid>
            </Grid>
            <U.Gap size={50} />
            <Grid container xs={12} justify="center">
              <Grid item container xs={12} spacing={3}>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://oferta.empowerdata.com.br/excel"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                      Curso completo de Excel
                    </S.ButtonFooter>
                  </a>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://www.instagram.com/empowerdata/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                      Instagram
                    </S.ButtonFooter>
                  </a>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <a
                    href="https://www.youtube.com/channel/UCX8dXdLxlgBSKcOhb-ixuJg"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                      Youtube
                    </S.ButtonFooter>
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </S.ContainerLimit>
        </S.SeeMoreSection>

        <Grid container justify="center" className="text-center">
          <Grid>
            <U.Gap size={20} />
            <img src={logoWhite} alt="logo-branca" style={{ width: '64px' }} />

            <S.Text>Empowerdata © 2023 - CNPJ: 27.955.892/0001-30</S.Text>
            <U.Text>Todos os direitos reservados</U.Text>
            <U.Gap size={20} />
          </Grid>
        </Grid>
      </motion.div>

      {modalCertificate && (
        <Modal
          onClose={() => setModalCertificate(false)}
          hasButton
          size={70}
          white
          contentPadding={width > 768 ? '2rem' : '4rem 1.5rem 1.5rem 1.5rem'}
        >
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              md={8}
              container
              alignItems="center"
              justify="center"
            >
              {!loading.image && (
                <Grid
                  item
                  xs={12}
                  md={8}
                  container
                  alignItems="center"
                  justify="center"
                  style={{ height: 460 }}
                >
                  <Loading />
                </Grid>
              )}
              <img
                src={CertificateData.certificate_image}
                alt="certificado"
                style={loading.image ? { width: '100%' } : { display: 'none' }}
                onLoad={() => setLoading({ form: false, image: true })}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <U.Gap size={width > 768 ? 50 : 0} />
              <S.TitleCertificate>
                Parabéns, {CertificateData.name}!
              </S.TitleCertificate>
              <U.Gap size={width > 768 ? 20 : 10} />
              <U.Text black bold>
                Aproveite e compartilhe mais essa conquista no seu Linkedin!
              </U.Text>

              <U.Gap size={30} />
              <a
                href={`https://www.linkedin.com/shareArticle?mini=true&url=${CertificateData.certificate_image}`}
                target="_blank"
                rel="noreferrer"
              >
                <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                  <GrLinkedin size={20} color="#fff" /> Compartilhar no linkedIn
                </S.ButtonFooter>
              </a>
              <U.Gap size={20} />
              <a
                href={CertificateData.certificate}
                download="certificado.pdf"
                target="_blank"
                rel="noreferrer"
              >
                <S.ButtonFooter whileTap={{ scale: 0.95 }}>
                  <FaDownload size={20} color="#fff" /> Baixar certificado
                </S.ButtonFooter>
              </a>
            </Grid>
          </Grid>
        </Modal>
      )}
    </>
  );
};

export default Certificate;
